/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-09 09:46:54
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-07-25 10:49:18
 * @FilePath: /dbrank_b/src/routes/visualChart/components/Drawer/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import s from "./index.css";
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import Close from '../Close';
import { unmountComponentAtNode, unstable_renderSubtreeIntoContainer } from 'react-dom';

class Drawer extends Component {
  static propTypes = {
    visible: PropTypes.bool,
    children: PropTypes.node.isRequired,
    onClose: PropTypes.func,
    title: PropTypes.string,
    propsRef: PropTypes.func
  }

  drawerRef = null;
   
  constructor(props) {
    super(props);
    this.state = {
      opened: props.visible,
      active: props.visible,
    }
  }

  rootDom = null;
  componentDidMount() {
    this.rootDom = document.createElement('div');
    document.body.appendChild(this.rootDom);
    this.renderPortal(this.props)
  }

  componentWillUnmount() {
    unmountComponentAtNode(this.rootDom);
    document.body.removeChild(this.rootDom);
  }
  componentDidUpdate() {
    this.renderPortal(this.props);
  }

  onClose = () => {
    const { onClose } = this.props
    typeof onClose === 'function' && onClose();
  }

  setRef = (ref) => {
    const { propsRef } = this.props;
    propsRef && propsRef(ref)
  }

  renderPortal = (props) => {
    unstable_renderSubtreeIntoContainer(
      this, //代表当前组件
      <div ref={this.setRef} className={cx(s.drawer, props.visible && s.active)}>
        <div className={s.header}>
          <button type="button" className={s.close} onClick={this.onClose}>
            <span className={s.anticon}>
              <Close />
            </span>
          </button>
          <div className={s.title}>{props.title || '默认标题'}</div>
        </div>
        <div className={s.body}>{props.children}</div>
      </div>
      , // 塞进传送门的JSX
      this.rootDom // 传送门另一端的DOM node
    );
  }

  render() {
    return null;
  }
}

// export default Drawer;
export default withStyles(s)(Drawer);


// WEBPACK FOOTER //
// src/routes/visualChart/components/Drawer/index.js